import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import { HiCheck } from 'react-icons/hi';
import { match, P } from 'ts-pattern';
export const SelectionOptionBasic = t0 => {
  const $ = _c(12);
  const {
    title,
    checked,
    desc
  } = t0;
  let t1;
  if ($[0] !== checked) {
    t1 = checked && <HiCheck />;
    $[0] = checked;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = match(title).with(P.string, _temp).otherwise(() => title);
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex gap-2 items-center">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== desc) {
    t4 = match(desc).with(P.string, _temp2).otherwise(() => desc);
    $[7] = desc;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="flex flex-col max-w-[min(30em,90vw)]">{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
function _temp(title_0) {
  return <div className="font-semibold">{title_0}</div>;
}
function _temp2(desc_0) {
  return <div className="text-sm opacity-60">{desc_0}</div>;
}